/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ActivityPointsManualRouteImport } from './routes/activity-points-manual'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAdminRouteImport } from './routes/_authed/_admin'
import { Route as AuthedAbsencesRouteImport } from './routes/_authed/absences'
import { Route as AuthedBossTalentsRouteImport } from './routes/_authed/boss-talents'
import { Route as AuthedEventsRouteImport } from './routes/_authed/events'
import { Route as AuthedGuildWarRosterRouteImport } from './routes/_authed/guild-war-roster'
import { Route as AuthedGuildWarSignupRouteImport } from './routes/_authed/guild-war-signup'
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile'
import { Route as AuthedThemeBuilderRouteImport } from './routes/_authed/theme-builder'
import { Route as AuthedUnauthorizedRouteImport } from './routes/_authed/unauthorized'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthedAdminAbsenceReviewRouteImport } from './routes/_authed/_admin/absence-review'
import { Route as AuthedAdminActivityLevelsRouteImport } from './routes/_authed/_admin/activity-levels'
import { Route as AuthedAdminBirthdaysRouteImport } from './routes/_authed/_admin/birthdays'
import { Route as AuthedAdminDailyContentRouteImport } from './routes/_authed/_admin/daily-content'
import { Route as AuthedAdminGuildEventsRouteImport } from './routes/_authed/_admin/guild-events'
import { Route as AuthedAdminMembersRouteImport } from './routes/_authed/_admin/members'
import { Route as AuthedAdminTalentConfigRouteImport } from './routes/_authed/_admin/talent-config'
import { Route as AuthedAdminTalentOverviewRouteImport } from './routes/_authed/_admin/talent-overview'
import { Route as AuthedEventsEventIdRouteImport } from './routes/_authed/events.$eventId'
import { Route as AuthedAdminActivityLevelsIndexRouteImport } from './routes/_authed/_admin/activity-levels.index'
import { Route as AuthedAdminActivityLevelsAchievementsRouteImport } from './routes/_authed/_admin/activity-levels.achievements'
import { Route as AuthedAdminActivityLevelsLeaderboardRouteImport } from './routes/_authed/_admin/activity-levels.leaderboard'
import { Route as AuthedAdminActivityLevelsMembersRouteImport } from './routes/_authed/_admin/activity-levels.members'
import { Route as AuthedAdminBirthdaysIndexRouteImport } from './routes/_authed/_admin/birthdays.index'
import { Route as AuthedAdminGuildEventsIndexRouteImport } from './routes/_authed/_admin/guild-events.index'
import { Route as AuthedAdminGuildEventsEventIdRouteImport } from './routes/_authed/_admin/guild-events.$eventId'
import { Route as AuthedAdminGuildEventsArchivedRouteImport } from './routes/_authed/_admin/guild-events.archived'
import { Route as AuthedAdminGuildEventsNewRouteImport } from './routes/_authed/_admin/guild-events.new'
import { Route as AuthedAdminGuildEventsSchedulesRouteImport } from './routes/_authed/_admin/guild-events/schedules'
import { Route as AuthedAdminGuildWarActionsRouteImport } from './routes/_authed/_admin/guild-war/actions'
import { Route as AuthedAdminGuildWarCandidatePoolRouteImport } from './routes/_authed/_admin/guild-war/candidate-pool'
import { Route as AuthedAdminGuildWarPermanentMembershipRouteImport } from './routes/_authed/_admin/guild-war/permanent-membership'
import { Route as AuthedAdminGuildWarTeamBoardRouteImport } from './routes/_authed/_admin/guild-war/team-board'
import { Route as AuthedAdminGuildWarWeeksRouteImport } from './routes/_authed/_admin/guild-war/weeks'
import { Route as AuthedAdminMembersIndexRouteImport } from './routes/_authed/_admin/members.index'
import { Route as AuthedAdminMembersMemberIdRouteImport } from './routes/_authed/_admin/members.$memberId'
import { Route as AuthedAdminMembersTitleSuggestionsRouteImport } from './routes/_authed/_admin/members.title-suggestions'
import { Route as AuthedAdminTalentMembersUserIdRouteImport } from './routes/_authed/_admin/talent-members.$userId'
import { Route as AuthedAdminGuildEventsSchedulesScheduleIdRouteImport } from './routes/_authed/_admin/guild-events/schedules/$scheduleId'
import { Route as AuthedAdminGuildEventsSchedulesNewRouteImport } from './routes/_authed/_admin/guild-events/schedules/new'

const GuildWarGuideLazyRouteImport = createFileRoute('/guild-war-guide')()
const AuthedAdminGuildEventsSchedulesIndexLazyRouteImport = createFileRoute(
  '/_authed/_admin/guild-events/schedules/',
)()

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityPointsManualRoute = ActivityPointsManualRouteImport.update({
  id: '/activity-points-manual',
  path: '/activity-points-manual',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildWarGuideLazyRoute = GuildWarGuideLazyRouteImport.update({
  id: '/guild-war-guide',
  path: '/guild-war-guide',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/guild-war-guide.lazy').then((d) => d.Route),
)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAbsencesRoute = AuthedAbsencesRouteImport.update({
  id: '/absences',
  path: '/absences',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBossTalentsRoute = AuthedBossTalentsRouteImport.update({
  id: '/boss-talents',
  path: '/boss-talents',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEventsRoute = AuthedEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGuildWarRosterRoute = AuthedGuildWarRosterRouteImport.update({
  id: '/guild-war-roster',
  path: '/guild-war-roster',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGuildWarSignupRoute = AuthedGuildWarSignupRouteImport.update({
  id: '/guild-war-signup',
  path: '/guild-war-signup',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedThemeBuilderRoute = AuthedThemeBuilderRouteImport.update({
  id: '/theme-builder',
  path: '/theme-builder',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUnauthorizedRoute = AuthedUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedAdminAbsenceReviewRoute =
  AuthedAdminAbsenceReviewRouteImport.update({
    id: '/absence-review',
    path: '/absence-review',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminActivityLevelsRoute =
  AuthedAdminActivityLevelsRouteImport.update({
    id: '/activity-levels',
    path: '/activity-levels',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminBirthdaysRoute = AuthedAdminBirthdaysRouteImport.update({
  id: '/birthdays',
  path: '/birthdays',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminDailyContentRoute = AuthedAdminDailyContentRouteImport.update({
  id: '/daily-content',
  path: '/daily-content',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminGuildEventsRoute = AuthedAdminGuildEventsRouteImport.update({
  id: '/guild-events',
  path: '/guild-events',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminMembersRoute = AuthedAdminMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminTalentConfigRoute = AuthedAdminTalentConfigRouteImport.update({
  id: '/talent-config',
  path: '/talent-config',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminTalentOverviewRoute =
  AuthedAdminTalentOverviewRouteImport.update({
    id: '/talent-overview',
    path: '/talent-overview',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedEventsEventIdRoute = AuthedEventsEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => AuthedEventsRoute,
} as any)
const AuthedAdminActivityLevelsIndexRoute =
  AuthedAdminActivityLevelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAdminActivityLevelsRoute,
  } as any)
const AuthedAdminActivityLevelsAchievementsRoute =
  AuthedAdminActivityLevelsAchievementsRouteImport.update({
    id: '/achievements',
    path: '/achievements',
    getParentRoute: () => AuthedAdminActivityLevelsRoute,
  } as any)
const AuthedAdminActivityLevelsLeaderboardRoute =
  AuthedAdminActivityLevelsLeaderboardRouteImport.update({
    id: '/leaderboard',
    path: '/leaderboard',
    getParentRoute: () => AuthedAdminActivityLevelsRoute,
  } as any)
const AuthedAdminActivityLevelsMembersRoute =
  AuthedAdminActivityLevelsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthedAdminActivityLevelsRoute,
  } as any)
const AuthedAdminBirthdaysIndexRoute =
  AuthedAdminBirthdaysIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAdminBirthdaysRoute,
  } as any)
const AuthedAdminGuildEventsIndexRoute =
  AuthedAdminGuildEventsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAdminGuildEventsRoute,
  } as any)
const AuthedAdminGuildEventsEventIdRoute =
  AuthedAdminGuildEventsEventIdRouteImport.update({
    id: '/$eventId',
    path: '/$eventId',
    getParentRoute: () => AuthedAdminGuildEventsRoute,
  } as any)
const AuthedAdminGuildEventsArchivedRoute =
  AuthedAdminGuildEventsArchivedRouteImport.update({
    id: '/archived',
    path: '/archived',
    getParentRoute: () => AuthedAdminGuildEventsRoute,
  } as any)
const AuthedAdminGuildEventsNewRoute =
  AuthedAdminGuildEventsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedAdminGuildEventsRoute,
  } as any)
const AuthedAdminGuildEventsSchedulesRoute =
  AuthedAdminGuildEventsSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => AuthedAdminGuildEventsRoute,
  } as any)
const AuthedAdminGuildWarActionsRoute =
  AuthedAdminGuildWarActionsRouteImport.update({
    id: '/guild-war/actions',
    path: '/guild-war/actions',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminGuildWarCandidatePoolRoute =
  AuthedAdminGuildWarCandidatePoolRouteImport.update({
    id: '/guild-war/candidate-pool',
    path: '/guild-war/candidate-pool',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminGuildWarPermanentMembershipRoute =
  AuthedAdminGuildWarPermanentMembershipRouteImport.update({
    id: '/guild-war/permanent-membership',
    path: '/guild-war/permanent-membership',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminGuildWarTeamBoardRoute =
  AuthedAdminGuildWarTeamBoardRouteImport.update({
    id: '/guild-war/team-board',
    path: '/guild-war/team-board',
    getParentRoute: () => AuthedAdminRoute,
  } as any).lazy(() =>
    import('./routes/_authed/_admin/guild-war/team-board.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthedAdminGuildWarWeeksRoute =
  AuthedAdminGuildWarWeeksRouteImport.update({
    id: '/guild-war/weeks',
    path: '/guild-war/weeks',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminMembersIndexRoute = AuthedAdminMembersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminMembersRoute,
} as any)
const AuthedAdminMembersMemberIdRoute =
  AuthedAdminMembersMemberIdRouteImport.update({
    id: '/$memberId',
    path: '/$memberId',
    getParentRoute: () => AuthedAdminMembersRoute,
  } as any)
const AuthedAdminMembersTitleSuggestionsRoute =
  AuthedAdminMembersTitleSuggestionsRouteImport.update({
    id: '/title-suggestions',
    path: '/title-suggestions',
    getParentRoute: () => AuthedAdminMembersRoute,
  } as any)
const AuthedAdminTalentMembersUserIdRoute =
  AuthedAdminTalentMembersUserIdRouteImport.update({
    id: '/talent-members/$userId',
    path: '/talent-members/$userId',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminGuildEventsSchedulesIndexLazyRoute =
  AuthedAdminGuildEventsSchedulesIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAdminGuildEventsSchedulesRoute,
  } as any).lazy(() =>
    import('./routes/_authed/_admin/guild-events/schedules/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthedAdminGuildEventsSchedulesScheduleIdRoute =
  AuthedAdminGuildEventsSchedulesScheduleIdRouteImport.update({
    id: '/$scheduleId',
    path: '/$scheduleId',
    getParentRoute: () => AuthedAdminGuildEventsSchedulesRoute,
  } as any)
const AuthedAdminGuildEventsSchedulesNewRoute =
  AuthedAdminGuildEventsSchedulesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedAdminGuildEventsSchedulesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/activity-points-manual': typeof ActivityPointsManualRoute
  '/guild-war-guide': typeof GuildWarGuideLazyRoute
  '/absences': typeof AuthedAbsencesRoute
  '/boss-talents': typeof AuthedBossTalentsRoute
  '/events': typeof AuthedEventsRouteWithChildren
  '/guild-war-roster': typeof AuthedGuildWarRosterRoute
  '/guild-war-signup': typeof AuthedGuildWarSignupRoute
  '/profile': typeof AuthedProfileRoute
  '/theme-builder': typeof AuthedThemeBuilderRoute
  '/unauthorized': typeof AuthedUnauthorizedRoute
  '/login': typeof PublicLoginRoute
  '/absence-review': typeof AuthedAdminAbsenceReviewRoute
  '/activity-levels': typeof AuthedAdminActivityLevelsRouteWithChildren
  '/birthdays': typeof AuthedAdminBirthdaysRouteWithChildren
  '/daily-content': typeof AuthedAdminDailyContentRoute
  '/guild-events': typeof AuthedAdminGuildEventsRouteWithChildren
  '/members': typeof AuthedAdminMembersRouteWithChildren
  '/talent-config': typeof AuthedAdminTalentConfigRoute
  '/talent-overview': typeof AuthedAdminTalentOverviewRoute
  '/events/$eventId': typeof AuthedEventsEventIdRoute
  '/activity-levels/achievements': typeof AuthedAdminActivityLevelsAchievementsRoute
  '/activity-levels/leaderboard': typeof AuthedAdminActivityLevelsLeaderboardRoute
  '/activity-levels/members': typeof AuthedAdminActivityLevelsMembersRoute
  '/guild-events/$eventId': typeof AuthedAdminGuildEventsEventIdRoute
  '/guild-events/archived': typeof AuthedAdminGuildEventsArchivedRoute
  '/guild-events/new': typeof AuthedAdminGuildEventsNewRoute
  '/guild-events/schedules': typeof AuthedAdminGuildEventsSchedulesRouteWithChildren
  '/guild-war/actions': typeof AuthedAdminGuildWarActionsRoute
  '/guild-war/candidate-pool': typeof AuthedAdminGuildWarCandidatePoolRoute
  '/guild-war/permanent-membership': typeof AuthedAdminGuildWarPermanentMembershipRoute
  '/guild-war/team-board': typeof AuthedAdminGuildWarTeamBoardRoute
  '/guild-war/weeks': typeof AuthedAdminGuildWarWeeksRoute
  '/members/$memberId': typeof AuthedAdminMembersMemberIdRoute
  '/members/title-suggestions': typeof AuthedAdminMembersTitleSuggestionsRoute
  '/talent-members/$userId': typeof AuthedAdminTalentMembersUserIdRoute
  '/activity-levels/': typeof AuthedAdminActivityLevelsIndexRoute
  '/birthdays/': typeof AuthedAdminBirthdaysIndexRoute
  '/guild-events/': typeof AuthedAdminGuildEventsIndexRoute
  '/members/': typeof AuthedAdminMembersIndexRoute
  '/guild-events/schedules/$scheduleId': typeof AuthedAdminGuildEventsSchedulesScheduleIdRoute
  '/guild-events/schedules/new': typeof AuthedAdminGuildEventsSchedulesNewRoute
  '/guild-events/schedules/': typeof AuthedAdminGuildEventsSchedulesIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/activity-points-manual': typeof ActivityPointsManualRoute
  '/guild-war-guide': typeof GuildWarGuideLazyRoute
  '/absences': typeof AuthedAbsencesRoute
  '/boss-talents': typeof AuthedBossTalentsRoute
  '/events': typeof AuthedEventsRouteWithChildren
  '/guild-war-roster': typeof AuthedGuildWarRosterRoute
  '/guild-war-signup': typeof AuthedGuildWarSignupRoute
  '/profile': typeof AuthedProfileRoute
  '/theme-builder': typeof AuthedThemeBuilderRoute
  '/unauthorized': typeof AuthedUnauthorizedRoute
  '/login': typeof PublicLoginRoute
  '/absence-review': typeof AuthedAdminAbsenceReviewRoute
  '/daily-content': typeof AuthedAdminDailyContentRoute
  '/talent-config': typeof AuthedAdminTalentConfigRoute
  '/talent-overview': typeof AuthedAdminTalentOverviewRoute
  '/events/$eventId': typeof AuthedEventsEventIdRoute
  '/activity-levels/achievements': typeof AuthedAdminActivityLevelsAchievementsRoute
  '/activity-levels/leaderboard': typeof AuthedAdminActivityLevelsLeaderboardRoute
  '/activity-levels/members': typeof AuthedAdminActivityLevelsMembersRoute
  '/guild-events/$eventId': typeof AuthedAdminGuildEventsEventIdRoute
  '/guild-events/archived': typeof AuthedAdminGuildEventsArchivedRoute
  '/guild-events/new': typeof AuthedAdminGuildEventsNewRoute
  '/guild-war/actions': typeof AuthedAdminGuildWarActionsRoute
  '/guild-war/candidate-pool': typeof AuthedAdminGuildWarCandidatePoolRoute
  '/guild-war/permanent-membership': typeof AuthedAdminGuildWarPermanentMembershipRoute
  '/guild-war/team-board': typeof AuthedAdminGuildWarTeamBoardRoute
  '/guild-war/weeks': typeof AuthedAdminGuildWarWeeksRoute
  '/members/$memberId': typeof AuthedAdminMembersMemberIdRoute
  '/members/title-suggestions': typeof AuthedAdminMembersTitleSuggestionsRoute
  '/talent-members/$userId': typeof AuthedAdminTalentMembersUserIdRoute
  '/activity-levels': typeof AuthedAdminActivityLevelsIndexRoute
  '/birthdays': typeof AuthedAdminBirthdaysIndexRoute
  '/guild-events': typeof AuthedAdminGuildEventsIndexRoute
  '/members': typeof AuthedAdminMembersIndexRoute
  '/guild-events/schedules/$scheduleId': typeof AuthedAdminGuildEventsSchedulesScheduleIdRoute
  '/guild-events/schedules/new': typeof AuthedAdminGuildEventsSchedulesNewRoute
  '/guild-events/schedules': typeof AuthedAdminGuildEventsSchedulesIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/activity-points-manual': typeof ActivityPointsManualRoute
  '/guild-war-guide': typeof GuildWarGuideLazyRoute
  '/_authed/_admin': typeof AuthedAdminRouteWithChildren
  '/_authed/absences': typeof AuthedAbsencesRoute
  '/_authed/boss-talents': typeof AuthedBossTalentsRoute
  '/_authed/events': typeof AuthedEventsRouteWithChildren
  '/_authed/guild-war-roster': typeof AuthedGuildWarRosterRoute
  '/_authed/guild-war-signup': typeof AuthedGuildWarSignupRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/theme-builder': typeof AuthedThemeBuilderRoute
  '/_authed/unauthorized': typeof AuthedUnauthorizedRoute
  '/_public/login': typeof PublicLoginRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/_admin/absence-review': typeof AuthedAdminAbsenceReviewRoute
  '/_authed/_admin/activity-levels': typeof AuthedAdminActivityLevelsRouteWithChildren
  '/_authed/_admin/birthdays': typeof AuthedAdminBirthdaysRouteWithChildren
  '/_authed/_admin/daily-content': typeof AuthedAdminDailyContentRoute
  '/_authed/_admin/guild-events': typeof AuthedAdminGuildEventsRouteWithChildren
  '/_authed/_admin/members': typeof AuthedAdminMembersRouteWithChildren
  '/_authed/_admin/talent-config': typeof AuthedAdminTalentConfigRoute
  '/_authed/_admin/talent-overview': typeof AuthedAdminTalentOverviewRoute
  '/_authed/events/$eventId': typeof AuthedEventsEventIdRoute
  '/_authed/_admin/activity-levels/achievements': typeof AuthedAdminActivityLevelsAchievementsRoute
  '/_authed/_admin/activity-levels/leaderboard': typeof AuthedAdminActivityLevelsLeaderboardRoute
  '/_authed/_admin/activity-levels/members': typeof AuthedAdminActivityLevelsMembersRoute
  '/_authed/_admin/guild-events/$eventId': typeof AuthedAdminGuildEventsEventIdRoute
  '/_authed/_admin/guild-events/archived': typeof AuthedAdminGuildEventsArchivedRoute
  '/_authed/_admin/guild-events/new': typeof AuthedAdminGuildEventsNewRoute
  '/_authed/_admin/guild-events/schedules': typeof AuthedAdminGuildEventsSchedulesRouteWithChildren
  '/_authed/_admin/guild-war/actions': typeof AuthedAdminGuildWarActionsRoute
  '/_authed/_admin/guild-war/candidate-pool': typeof AuthedAdminGuildWarCandidatePoolRoute
  '/_authed/_admin/guild-war/permanent-membership': typeof AuthedAdminGuildWarPermanentMembershipRoute
  '/_authed/_admin/guild-war/team-board': typeof AuthedAdminGuildWarTeamBoardRoute
  '/_authed/_admin/guild-war/weeks': typeof AuthedAdminGuildWarWeeksRoute
  '/_authed/_admin/members/$memberId': typeof AuthedAdminMembersMemberIdRoute
  '/_authed/_admin/members/title-suggestions': typeof AuthedAdminMembersTitleSuggestionsRoute
  '/_authed/_admin/talent-members/$userId': typeof AuthedAdminTalentMembersUserIdRoute
  '/_authed/_admin/activity-levels/': typeof AuthedAdminActivityLevelsIndexRoute
  '/_authed/_admin/birthdays/': typeof AuthedAdminBirthdaysIndexRoute
  '/_authed/_admin/guild-events/': typeof AuthedAdminGuildEventsIndexRoute
  '/_authed/_admin/members/': typeof AuthedAdminMembersIndexRoute
  '/_authed/_admin/guild-events/schedules/$scheduleId': typeof AuthedAdminGuildEventsSchedulesScheduleIdRoute
  '/_authed/_admin/guild-events/schedules/new': typeof AuthedAdminGuildEventsSchedulesNewRoute
  '/_authed/_admin/guild-events/schedules/': typeof AuthedAdminGuildEventsSchedulesIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity-points-manual'
    | '/guild-war-guide'
    | '/absences'
    | '/boss-talents'
    | '/events'
    | '/guild-war-roster'
    | '/guild-war-signup'
    | '/profile'
    | '/theme-builder'
    | '/unauthorized'
    | '/login'
    | '/absence-review'
    | '/activity-levels'
    | '/birthdays'
    | '/daily-content'
    | '/guild-events'
    | '/members'
    | '/talent-config'
    | '/talent-overview'
    | '/events/$eventId'
    | '/activity-levels/achievements'
    | '/activity-levels/leaderboard'
    | '/activity-levels/members'
    | '/guild-events/$eventId'
    | '/guild-events/archived'
    | '/guild-events/new'
    | '/guild-events/schedules'
    | '/guild-war/actions'
    | '/guild-war/candidate-pool'
    | '/guild-war/permanent-membership'
    | '/guild-war/team-board'
    | '/guild-war/weeks'
    | '/members/$memberId'
    | '/members/title-suggestions'
    | '/talent-members/$userId'
    | '/activity-levels/'
    | '/birthdays/'
    | '/guild-events/'
    | '/members/'
    | '/guild-events/schedules/$scheduleId'
    | '/guild-events/schedules/new'
    | '/guild-events/schedules/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity-points-manual'
    | '/guild-war-guide'
    | '/absences'
    | '/boss-talents'
    | '/events'
    | '/guild-war-roster'
    | '/guild-war-signup'
    | '/profile'
    | '/theme-builder'
    | '/unauthorized'
    | '/login'
    | '/absence-review'
    | '/daily-content'
    | '/talent-config'
    | '/talent-overview'
    | '/events/$eventId'
    | '/activity-levels/achievements'
    | '/activity-levels/leaderboard'
    | '/activity-levels/members'
    | '/guild-events/$eventId'
    | '/guild-events/archived'
    | '/guild-events/new'
    | '/guild-war/actions'
    | '/guild-war/candidate-pool'
    | '/guild-war/permanent-membership'
    | '/guild-war/team-board'
    | '/guild-war/weeks'
    | '/members/$memberId'
    | '/members/title-suggestions'
    | '/talent-members/$userId'
    | '/activity-levels'
    | '/birthdays'
    | '/guild-events'
    | '/members'
    | '/guild-events/schedules/$scheduleId'
    | '/guild-events/schedules/new'
    | '/guild-events/schedules'
  id:
    | '__root__'
    | '/_authed'
    | '/_public'
    | '/activity-points-manual'
    | '/guild-war-guide'
    | '/_authed/_admin'
    | '/_authed/absences'
    | '/_authed/boss-talents'
    | '/_authed/events'
    | '/_authed/guild-war-roster'
    | '/_authed/guild-war-signup'
    | '/_authed/profile'
    | '/_authed/theme-builder'
    | '/_authed/unauthorized'
    | '/_public/login'
    | '/_authed/'
    | '/_authed/_admin/absence-review'
    | '/_authed/_admin/activity-levels'
    | '/_authed/_admin/birthdays'
    | '/_authed/_admin/daily-content'
    | '/_authed/_admin/guild-events'
    | '/_authed/_admin/members'
    | '/_authed/_admin/talent-config'
    | '/_authed/_admin/talent-overview'
    | '/_authed/events/$eventId'
    | '/_authed/_admin/activity-levels/achievements'
    | '/_authed/_admin/activity-levels/leaderboard'
    | '/_authed/_admin/activity-levels/members'
    | '/_authed/_admin/guild-events/$eventId'
    | '/_authed/_admin/guild-events/archived'
    | '/_authed/_admin/guild-events/new'
    | '/_authed/_admin/guild-events/schedules'
    | '/_authed/_admin/guild-war/actions'
    | '/_authed/_admin/guild-war/candidate-pool'
    | '/_authed/_admin/guild-war/permanent-membership'
    | '/_authed/_admin/guild-war/team-board'
    | '/_authed/_admin/guild-war/weeks'
    | '/_authed/_admin/members/$memberId'
    | '/_authed/_admin/members/title-suggestions'
    | '/_authed/_admin/talent-members/$userId'
    | '/_authed/_admin/activity-levels/'
    | '/_authed/_admin/birthdays/'
    | '/_authed/_admin/guild-events/'
    | '/_authed/_admin/members/'
    | '/_authed/_admin/guild-events/schedules/$scheduleId'
    | '/_authed/_admin/guild-events/schedules/new'
    | '/_authed/_admin/guild-events/schedules/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  ActivityPointsManualRoute: typeof ActivityPointsManualRoute
  GuildWarGuideLazyRoute: typeof GuildWarGuideLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity-points-manual': {
      id: '/activity-points-manual'
      path: '/activity-points-manual'
      fullPath: '/activity-points-manual'
      preLoaderRoute: typeof ActivityPointsManualRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guild-war-guide': {
      id: '/guild-war-guide'
      path: '/guild-war-guide'
      fullPath: '/guild-war-guide'
      preLoaderRoute: typeof GuildWarGuideLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_admin': {
      id: '/_authed/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/absences': {
      id: '/_authed/absences'
      path: '/absences'
      fullPath: '/absences'
      preLoaderRoute: typeof AuthedAbsencesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/boss-talents': {
      id: '/_authed/boss-talents'
      path: '/boss-talents'
      fullPath: '/boss-talents'
      preLoaderRoute: typeof AuthedBossTalentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/events': {
      id: '/_authed/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AuthedEventsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/guild-war-roster': {
      id: '/_authed/guild-war-roster'
      path: '/guild-war-roster'
      fullPath: '/guild-war-roster'
      preLoaderRoute: typeof AuthedGuildWarRosterRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/guild-war-signup': {
      id: '/_authed/guild-war-signup'
      path: '/guild-war-signup'
      fullPath: '/guild-war-signup'
      preLoaderRoute: typeof AuthedGuildWarSignupRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/theme-builder': {
      id: '/_authed/theme-builder'
      path: '/theme-builder'
      fullPath: '/theme-builder'
      preLoaderRoute: typeof AuthedThemeBuilderRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/unauthorized': {
      id: '/_authed/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AuthedUnauthorizedRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/_admin/absence-review': {
      id: '/_authed/_admin/absence-review'
      path: '/absence-review'
      fullPath: '/absence-review'
      preLoaderRoute: typeof AuthedAdminAbsenceReviewRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/activity-levels': {
      id: '/_authed/_admin/activity-levels'
      path: '/activity-levels'
      fullPath: '/activity-levels'
      preLoaderRoute: typeof AuthedAdminActivityLevelsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/birthdays': {
      id: '/_authed/_admin/birthdays'
      path: '/birthdays'
      fullPath: '/birthdays'
      preLoaderRoute: typeof AuthedAdminBirthdaysRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/daily-content': {
      id: '/_authed/_admin/daily-content'
      path: '/daily-content'
      fullPath: '/daily-content'
      preLoaderRoute: typeof AuthedAdminDailyContentRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/guild-events': {
      id: '/_authed/_admin/guild-events'
      path: '/guild-events'
      fullPath: '/guild-events'
      preLoaderRoute: typeof AuthedAdminGuildEventsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/members': {
      id: '/_authed/_admin/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AuthedAdminMembersRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/talent-config': {
      id: '/_authed/_admin/talent-config'
      path: '/talent-config'
      fullPath: '/talent-config'
      preLoaderRoute: typeof AuthedAdminTalentConfigRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/talent-overview': {
      id: '/_authed/_admin/talent-overview'
      path: '/talent-overview'
      fullPath: '/talent-overview'
      preLoaderRoute: typeof AuthedAdminTalentOverviewRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/events/$eventId': {
      id: '/_authed/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AuthedEventsEventIdRouteImport
      parentRoute: typeof AuthedEventsRoute
    }
    '/_authed/_admin/activity-levels/': {
      id: '/_authed/_admin/activity-levels/'
      path: '/'
      fullPath: '/activity-levels/'
      preLoaderRoute: typeof AuthedAdminActivityLevelsIndexRouteImport
      parentRoute: typeof AuthedAdminActivityLevelsRoute
    }
    '/_authed/_admin/activity-levels/achievements': {
      id: '/_authed/_admin/activity-levels/achievements'
      path: '/achievements'
      fullPath: '/activity-levels/achievements'
      preLoaderRoute: typeof AuthedAdminActivityLevelsAchievementsRouteImport
      parentRoute: typeof AuthedAdminActivityLevelsRoute
    }
    '/_authed/_admin/activity-levels/leaderboard': {
      id: '/_authed/_admin/activity-levels/leaderboard'
      path: '/leaderboard'
      fullPath: '/activity-levels/leaderboard'
      preLoaderRoute: typeof AuthedAdminActivityLevelsLeaderboardRouteImport
      parentRoute: typeof AuthedAdminActivityLevelsRoute
    }
    '/_authed/_admin/activity-levels/members': {
      id: '/_authed/_admin/activity-levels/members'
      path: '/members'
      fullPath: '/activity-levels/members'
      preLoaderRoute: typeof AuthedAdminActivityLevelsMembersRouteImport
      parentRoute: typeof AuthedAdminActivityLevelsRoute
    }
    '/_authed/_admin/birthdays/': {
      id: '/_authed/_admin/birthdays/'
      path: '/'
      fullPath: '/birthdays/'
      preLoaderRoute: typeof AuthedAdminBirthdaysIndexRouteImport
      parentRoute: typeof AuthedAdminBirthdaysRoute
    }
    '/_authed/_admin/guild-events/': {
      id: '/_authed/_admin/guild-events/'
      path: '/'
      fullPath: '/guild-events/'
      preLoaderRoute: typeof AuthedAdminGuildEventsIndexRouteImport
      parentRoute: typeof AuthedAdminGuildEventsRoute
    }
    '/_authed/_admin/guild-events/$eventId': {
      id: '/_authed/_admin/guild-events/$eventId'
      path: '/$eventId'
      fullPath: '/guild-events/$eventId'
      preLoaderRoute: typeof AuthedAdminGuildEventsEventIdRouteImport
      parentRoute: typeof AuthedAdminGuildEventsRoute
    }
    '/_authed/_admin/guild-events/archived': {
      id: '/_authed/_admin/guild-events/archived'
      path: '/archived'
      fullPath: '/guild-events/archived'
      preLoaderRoute: typeof AuthedAdminGuildEventsArchivedRouteImport
      parentRoute: typeof AuthedAdminGuildEventsRoute
    }
    '/_authed/_admin/guild-events/new': {
      id: '/_authed/_admin/guild-events/new'
      path: '/new'
      fullPath: '/guild-events/new'
      preLoaderRoute: typeof AuthedAdminGuildEventsNewRouteImport
      parentRoute: typeof AuthedAdminGuildEventsRoute
    }
    '/_authed/_admin/guild-events/schedules': {
      id: '/_authed/_admin/guild-events/schedules'
      path: '/schedules'
      fullPath: '/guild-events/schedules'
      preLoaderRoute: typeof AuthedAdminGuildEventsSchedulesRouteImport
      parentRoute: typeof AuthedAdminGuildEventsRoute
    }
    '/_authed/_admin/guild-war/actions': {
      id: '/_authed/_admin/guild-war/actions'
      path: '/guild-war/actions'
      fullPath: '/guild-war/actions'
      preLoaderRoute: typeof AuthedAdminGuildWarActionsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/guild-war/candidate-pool': {
      id: '/_authed/_admin/guild-war/candidate-pool'
      path: '/guild-war/candidate-pool'
      fullPath: '/guild-war/candidate-pool'
      preLoaderRoute: typeof AuthedAdminGuildWarCandidatePoolRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/guild-war/permanent-membership': {
      id: '/_authed/_admin/guild-war/permanent-membership'
      path: '/guild-war/permanent-membership'
      fullPath: '/guild-war/permanent-membership'
      preLoaderRoute: typeof AuthedAdminGuildWarPermanentMembershipRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/guild-war/team-board': {
      id: '/_authed/_admin/guild-war/team-board'
      path: '/guild-war/team-board'
      fullPath: '/guild-war/team-board'
      preLoaderRoute: typeof AuthedAdminGuildWarTeamBoardRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/guild-war/weeks': {
      id: '/_authed/_admin/guild-war/weeks'
      path: '/guild-war/weeks'
      fullPath: '/guild-war/weeks'
      preLoaderRoute: typeof AuthedAdminGuildWarWeeksRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/members/': {
      id: '/_authed/_admin/members/'
      path: '/'
      fullPath: '/members/'
      preLoaderRoute: typeof AuthedAdminMembersIndexRouteImport
      parentRoute: typeof AuthedAdminMembersRoute
    }
    '/_authed/_admin/members/$memberId': {
      id: '/_authed/_admin/members/$memberId'
      path: '/$memberId'
      fullPath: '/members/$memberId'
      preLoaderRoute: typeof AuthedAdminMembersMemberIdRouteImport
      parentRoute: typeof AuthedAdminMembersRoute
    }
    '/_authed/_admin/members/title-suggestions': {
      id: '/_authed/_admin/members/title-suggestions'
      path: '/title-suggestions'
      fullPath: '/members/title-suggestions'
      preLoaderRoute: typeof AuthedAdminMembersTitleSuggestionsRouteImport
      parentRoute: typeof AuthedAdminMembersRoute
    }
    '/_authed/_admin/talent-members/$userId': {
      id: '/_authed/_admin/talent-members/$userId'
      path: '/talent-members/$userId'
      fullPath: '/talent-members/$userId'
      preLoaderRoute: typeof AuthedAdminTalentMembersUserIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/guild-events/schedules/': {
      id: '/_authed/_admin/guild-events/schedules/'
      path: '/'
      fullPath: '/guild-events/schedules/'
      preLoaderRoute: typeof AuthedAdminGuildEventsSchedulesIndexLazyRouteImport
      parentRoute: typeof AuthedAdminGuildEventsSchedulesRoute
    }
    '/_authed/_admin/guild-events/schedules/$scheduleId': {
      id: '/_authed/_admin/guild-events/schedules/$scheduleId'
      path: '/$scheduleId'
      fullPath: '/guild-events/schedules/$scheduleId'
      preLoaderRoute: typeof AuthedAdminGuildEventsSchedulesScheduleIdRouteImport
      parentRoute: typeof AuthedAdminGuildEventsSchedulesRoute
    }
    '/_authed/_admin/guild-events/schedules/new': {
      id: '/_authed/_admin/guild-events/schedules/new'
      path: '/new'
      fullPath: '/guild-events/schedules/new'
      preLoaderRoute: typeof AuthedAdminGuildEventsSchedulesNewRouteImport
      parentRoute: typeof AuthedAdminGuildEventsSchedulesRoute
    }
  }
}

interface AuthedAdminActivityLevelsRouteChildren {
  AuthedAdminActivityLevelsAchievementsRoute: typeof AuthedAdminActivityLevelsAchievementsRoute
  AuthedAdminActivityLevelsLeaderboardRoute: typeof AuthedAdminActivityLevelsLeaderboardRoute
  AuthedAdminActivityLevelsMembersRoute: typeof AuthedAdminActivityLevelsMembersRoute
  AuthedAdminActivityLevelsIndexRoute: typeof AuthedAdminActivityLevelsIndexRoute
}

const AuthedAdminActivityLevelsRouteChildren: AuthedAdminActivityLevelsRouteChildren =
  {
    AuthedAdminActivityLevelsAchievementsRoute:
      AuthedAdminActivityLevelsAchievementsRoute,
    AuthedAdminActivityLevelsLeaderboardRoute:
      AuthedAdminActivityLevelsLeaderboardRoute,
    AuthedAdminActivityLevelsMembersRoute:
      AuthedAdminActivityLevelsMembersRoute,
    AuthedAdminActivityLevelsIndexRoute: AuthedAdminActivityLevelsIndexRoute,
  }

const AuthedAdminActivityLevelsRouteWithChildren =
  AuthedAdminActivityLevelsRoute._addFileChildren(
    AuthedAdminActivityLevelsRouteChildren,
  )

interface AuthedAdminBirthdaysRouteChildren {
  AuthedAdminBirthdaysIndexRoute: typeof AuthedAdminBirthdaysIndexRoute
}

const AuthedAdminBirthdaysRouteChildren: AuthedAdminBirthdaysRouteChildren = {
  AuthedAdminBirthdaysIndexRoute: AuthedAdminBirthdaysIndexRoute,
}

const AuthedAdminBirthdaysRouteWithChildren =
  AuthedAdminBirthdaysRoute._addFileChildren(AuthedAdminBirthdaysRouteChildren)

interface AuthedAdminGuildEventsSchedulesRouteChildren {
  AuthedAdminGuildEventsSchedulesScheduleIdRoute: typeof AuthedAdminGuildEventsSchedulesScheduleIdRoute
  AuthedAdminGuildEventsSchedulesNewRoute: typeof AuthedAdminGuildEventsSchedulesNewRoute
  AuthedAdminGuildEventsSchedulesIndexLazyRoute: typeof AuthedAdminGuildEventsSchedulesIndexLazyRoute
}

const AuthedAdminGuildEventsSchedulesRouteChildren: AuthedAdminGuildEventsSchedulesRouteChildren =
  {
    AuthedAdminGuildEventsSchedulesScheduleIdRoute:
      AuthedAdminGuildEventsSchedulesScheduleIdRoute,
    AuthedAdminGuildEventsSchedulesNewRoute:
      AuthedAdminGuildEventsSchedulesNewRoute,
    AuthedAdminGuildEventsSchedulesIndexLazyRoute:
      AuthedAdminGuildEventsSchedulesIndexLazyRoute,
  }

const AuthedAdminGuildEventsSchedulesRouteWithChildren =
  AuthedAdminGuildEventsSchedulesRoute._addFileChildren(
    AuthedAdminGuildEventsSchedulesRouteChildren,
  )

interface AuthedAdminGuildEventsRouteChildren {
  AuthedAdminGuildEventsEventIdRoute: typeof AuthedAdminGuildEventsEventIdRoute
  AuthedAdminGuildEventsArchivedRoute: typeof AuthedAdminGuildEventsArchivedRoute
  AuthedAdminGuildEventsNewRoute: typeof AuthedAdminGuildEventsNewRoute
  AuthedAdminGuildEventsSchedulesRoute: typeof AuthedAdminGuildEventsSchedulesRouteWithChildren
  AuthedAdminGuildEventsIndexRoute: typeof AuthedAdminGuildEventsIndexRoute
}

const AuthedAdminGuildEventsRouteChildren: AuthedAdminGuildEventsRouteChildren =
  {
    AuthedAdminGuildEventsEventIdRoute: AuthedAdminGuildEventsEventIdRoute,
    AuthedAdminGuildEventsArchivedRoute: AuthedAdminGuildEventsArchivedRoute,
    AuthedAdminGuildEventsNewRoute: AuthedAdminGuildEventsNewRoute,
    AuthedAdminGuildEventsSchedulesRoute:
      AuthedAdminGuildEventsSchedulesRouteWithChildren,
    AuthedAdminGuildEventsIndexRoute: AuthedAdminGuildEventsIndexRoute,
  }

const AuthedAdminGuildEventsRouteWithChildren =
  AuthedAdminGuildEventsRoute._addFileChildren(
    AuthedAdminGuildEventsRouteChildren,
  )

interface AuthedAdminMembersRouteChildren {
  AuthedAdminMembersMemberIdRoute: typeof AuthedAdminMembersMemberIdRoute
  AuthedAdminMembersTitleSuggestionsRoute: typeof AuthedAdminMembersTitleSuggestionsRoute
  AuthedAdminMembersIndexRoute: typeof AuthedAdminMembersIndexRoute
}

const AuthedAdminMembersRouteChildren: AuthedAdminMembersRouteChildren = {
  AuthedAdminMembersMemberIdRoute: AuthedAdminMembersMemberIdRoute,
  AuthedAdminMembersTitleSuggestionsRoute:
    AuthedAdminMembersTitleSuggestionsRoute,
  AuthedAdminMembersIndexRoute: AuthedAdminMembersIndexRoute,
}

const AuthedAdminMembersRouteWithChildren =
  AuthedAdminMembersRoute._addFileChildren(AuthedAdminMembersRouteChildren)

interface AuthedAdminRouteChildren {
  AuthedAdminAbsenceReviewRoute: typeof AuthedAdminAbsenceReviewRoute
  AuthedAdminActivityLevelsRoute: typeof AuthedAdminActivityLevelsRouteWithChildren
  AuthedAdminBirthdaysRoute: typeof AuthedAdminBirthdaysRouteWithChildren
  AuthedAdminDailyContentRoute: typeof AuthedAdminDailyContentRoute
  AuthedAdminGuildEventsRoute: typeof AuthedAdminGuildEventsRouteWithChildren
  AuthedAdminMembersRoute: typeof AuthedAdminMembersRouteWithChildren
  AuthedAdminTalentConfigRoute: typeof AuthedAdminTalentConfigRoute
  AuthedAdminTalentOverviewRoute: typeof AuthedAdminTalentOverviewRoute
  AuthedAdminGuildWarActionsRoute: typeof AuthedAdminGuildWarActionsRoute
  AuthedAdminGuildWarCandidatePoolRoute: typeof AuthedAdminGuildWarCandidatePoolRoute
  AuthedAdminGuildWarPermanentMembershipRoute: typeof AuthedAdminGuildWarPermanentMembershipRoute
  AuthedAdminGuildWarTeamBoardRoute: typeof AuthedAdminGuildWarTeamBoardRoute
  AuthedAdminGuildWarWeeksRoute: typeof AuthedAdminGuildWarWeeksRoute
  AuthedAdminTalentMembersUserIdRoute: typeof AuthedAdminTalentMembersUserIdRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminAbsenceReviewRoute: AuthedAdminAbsenceReviewRoute,
  AuthedAdminActivityLevelsRoute: AuthedAdminActivityLevelsRouteWithChildren,
  AuthedAdminBirthdaysRoute: AuthedAdminBirthdaysRouteWithChildren,
  AuthedAdminDailyContentRoute: AuthedAdminDailyContentRoute,
  AuthedAdminGuildEventsRoute: AuthedAdminGuildEventsRouteWithChildren,
  AuthedAdminMembersRoute: AuthedAdminMembersRouteWithChildren,
  AuthedAdminTalentConfigRoute: AuthedAdminTalentConfigRoute,
  AuthedAdminTalentOverviewRoute: AuthedAdminTalentOverviewRoute,
  AuthedAdminGuildWarActionsRoute: AuthedAdminGuildWarActionsRoute,
  AuthedAdminGuildWarCandidatePoolRoute: AuthedAdminGuildWarCandidatePoolRoute,
  AuthedAdminGuildWarPermanentMembershipRoute:
    AuthedAdminGuildWarPermanentMembershipRoute,
  AuthedAdminGuildWarTeamBoardRoute: AuthedAdminGuildWarTeamBoardRoute,
  AuthedAdminGuildWarWeeksRoute: AuthedAdminGuildWarWeeksRoute,
  AuthedAdminTalentMembersUserIdRoute: AuthedAdminTalentMembersUserIdRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedEventsRouteChildren {
  AuthedEventsEventIdRoute: typeof AuthedEventsEventIdRoute
}

const AuthedEventsRouteChildren: AuthedEventsRouteChildren = {
  AuthedEventsEventIdRoute: AuthedEventsEventIdRoute,
}

const AuthedEventsRouteWithChildren = AuthedEventsRoute._addFileChildren(
  AuthedEventsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedAbsencesRoute: typeof AuthedAbsencesRoute
  AuthedBossTalentsRoute: typeof AuthedBossTalentsRoute
  AuthedEventsRoute: typeof AuthedEventsRouteWithChildren
  AuthedGuildWarRosterRoute: typeof AuthedGuildWarRosterRoute
  AuthedGuildWarSignupRoute: typeof AuthedGuildWarSignupRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedThemeBuilderRoute: typeof AuthedThemeBuilderRoute
  AuthedUnauthorizedRoute: typeof AuthedUnauthorizedRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedAbsencesRoute: AuthedAbsencesRoute,
  AuthedBossTalentsRoute: AuthedBossTalentsRoute,
  AuthedEventsRoute: AuthedEventsRouteWithChildren,
  AuthedGuildWarRosterRoute: AuthedGuildWarRosterRoute,
  AuthedGuildWarSignupRoute: AuthedGuildWarSignupRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedThemeBuilderRoute: AuthedThemeBuilderRoute,
  AuthedUnauthorizedRoute: AuthedUnauthorizedRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  ActivityPointsManualRoute: ActivityPointsManualRoute,
  GuildWarGuideLazyRoute: GuildWarGuideLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
